import { useCallback, useEffect } from "react";

import useService from "../../../../hooks/useService";
import { useEntityLocationsStore } from "../store/entityLocationsStore";

const getAddressLabel = (item) =>
  item?.address?.formatted ??
  item?.address?.raw ??
  item?.formattedAddress ??
  item?.formatted_address ??
  item?.rawAddress ??
  item?.raw_address ??
  "-";

const normalizeLocation = (item) => ({
  id: item?.id ?? item?.pk,
  name: item?.name ?? "-",
  locationId:
    item?.locationId ??
    item?.location_id ??
    item?.pk ??
    item?.id ??
    item?.entityId ??
    item?.entity_id ??
    "-",
  address: getAddressLabel(item),
});

export default function useEntityLocationsData(entityId) {
  const entityRepository = useService("repositories/entity-repository");
  const { currentPage, resLimit, setData, setLoading, setResultCount } = useEntityLocationsStore();

  const fetchEntityLocationsData = useCallback(async () => {
    if (!entityId) {
      return;
    }

    setLoading(true);
    try {
      const offset = (currentPage - 1) * resLimit;
      const response = await entityRepository.getRelatedProviders(entityId, {
        limit: resLimit,
        offset,
      });
      setData((response || []).map(normalizeLocation));
      setResultCount((await entityRepository.getTotalCount()) || 0);
    } catch (error) {
      console.error("Error fetching related providers:", error);
      setData([]);
      setResultCount(0);
    } finally {
      setLoading(false);
    }
  }, [currentPage, entityId, entityRepository, resLimit, setData, setLoading, setResultCount]);

  useEffect(() => {
    fetchEntityLocationsData();
  }, [fetchEntityLocationsData]);

  return { fetchEntityLocationsData };
}
